<template>
  <section class="al-bottom-fixed-panel-section">
    <al-link v-show="showMark" is-small :is-disabled="disableMark" @clickDone="$emit('mark-all')">
      Mark all as read
    </al-link>
    <al-link
      is-small
      :to="link"
      :is-external="isExternal"
      has-icon="chevron-right"
      @clickDone="$emit('view-all')"
    >
      View all {{ name }}
    </al-link>
  </section>
</template>

<script>
import AlLink from '../../core/basics/AlLink.vue';

/**
 * Footer section for notification panel, It is show at bottom side by default.
 * @displayName notification-footer
 */
export default {
  components: {
    AlLink
  },
  props: {
    /**
     * Notification section name
     */
    name: {
      type: String,
      default: ''
    },
    /**
     * URL to jump in "view all" link
     */
    link: {
      type: String,
      default: ''
    },
    /**
     * Enable to open the link in a new tab
     */
    isExternal: {
      type: Boolean,
      default: false
    },
    /**
     * show link to read all action.
     */
    showMark: {
      type: Boolean,
      default: false
    },
    /**
     * disable the read all action.
     */
    disableMark: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.al-bottom-fixed-panel-section {
  align-items: center;
  background-color: color(white, lighten, 1);
  //margin-right: spacing(11) + spacing(1);
  border-top: 1px solid color(white, darken, 2);
  bottom: 0;
  display: flex;
  height: 90px;
  margin-left: 0;
  max-width: 440px;
  position: fixed;
  width: calc(100% + #{spacing(14)});

  .al-link + .al-link {
    margin-left: spacing(7);
  }
}
</style>
